import { Icon } from '@/shared/ui/Icon';

/**
 * Os ícones das abas do painel — no celular e no tablet são eles que
 * identificam a aba (ver `Tabs`). Traço de 24px, o mesmo desenho dos ícones do
 * `enamed-feedback-lp` onde a aba tem par lá.
 */

/** Um lápis: o ensaio é onde a pessoa responde. */
export function EnsaioIcon() {
  return (
    <Icon size="sm">
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </Icon>
  );
}

/** Uma caixa marcada: o gabarito que a pessoa enviou (o "Gabarito" do ENAMED). */
export function GabaritoIcon() {
  return (
    <Icon size="sm">
      <path d="m9 11 3 3L22 4" />
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </Icon>
  );
}

/** Um troféu, como o Ranking do ENAMED. */
export function RankingIcon() {
  return (
    <Icon size="sm">
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
    </Icon>
  );
}

/** Uma lista: a prova oficial, questão por questão (as "Questões" do ENAMED). */
export function ProvaOficialIcon() {
  return (
    <Icon size="sm">
      <path d="M8 6h13" />
      <path d="M8 12h13" />
      <path d="M8 18h13" />
      <path d="M3 6h.01" />
      <path d="M3 12h.01" />
      <path d="M3 18h.01" />
    </Icon>
  );
}

/** Uma linha de tendência: a aba fala de padrão (o "Meu padrão" do ENAMED). */
export function DiagnosticoIcon() {
  return (
    <Icon size="sm">
      <path d="M3 17l5-6 4 3 5-7" />
      <path d="M17 7h4v4" />
    </Icon>
  );
}
